import React, { Component, Fragment } from "react";
import CreditHistoryList from "./CreditHistoryList";
import Footer from "../../utilities/Footer";
import AppContext from "../../../contexts/AppContext";
import NoData from "../../utilities/NoData";
import LoadingData from "../../utilities/LoadingData";
import {
    records, search
} from "../../../services/billing";
export class CreditHistory extends Component {
    state = {
        items: [],
        meta: {},
        query: "connects",
        search: false,
        create: false,
        loading: true,
        tableCount: "hide",
        filterItem: "all",

    };   

    componentDidMount() {
        
        search(this.state.query).then(response => {
                this.setState({
                    items: response.data,
                    meta: response.meta,                
                    loading: false
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }
    changePage = page => {
        search(this.state.query,page).then(response => {
            this.setState({ items: response.data, meta: response.meta });
        });
    };
 

    render() {
        return (
            <Fragment>              
                <div className="main-content mt-md-0 mt-6">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12">                              
                            <div className="header">
                                    <div className="header-body">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <ul className="header-title d-flex align-items-center">
                                                    <li>Credits</li>
													<li className="mr-2 ml-2"><i className="fe fe-chevron-right"></i></li>
													<li>Credits history</li>
                                                </ul>
                                            </div>
											
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                   
                                    <div className="table-responsive">
                                        {this.state.loading === true ? (
                                            <LoadingData></LoadingData>
                                        ) : this.state.items.length >= 1 ? (
                                            <table className="table table-sm table-nowrap card-table">
                                                <thead>
                                                    <tr>													  
                                                        <th>Plan</th>
                                                        <th>Price</th>
                                                        <th>Card</th>
                                                        <th>State</th>
                                                        <th>Date</th>
                                                       
                                                    </tr>
                                                </thead>
                                                <tbody className="list">
                                                    {this.state.items.map(
                                                        (item, index) => {
                                                            return (
                                                                <CreditHistoryList
                                                                    getItem={
                                                                        this
                                                                            .record
                                                                    }
                                                                    item={item}
                                                                    index={
                                                                        index
                                                                    }
                                                                    key={index}
                                                                ></CreditHistoryList>
                                                            );
                                                        }
                                                    )}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <NoData></NoData>
                                        )}
                                    </div>
                                    <div>
                                        <Footer
                                            changePage={this.changePage}
                                            totalPages={this.state.meta.pages}
                                            curentPage={this.state.meta.page}
                                        ></Footer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
CreditHistory.contextType = AppContext;
export default CreditHistory;



// WEBPACK FOOTER //
// ./src/components/writer/credits/CreditHistory.js